let font =[
  {
     name:'Roboto',
     title:'default font'
  },
  {
    name:'Vampire',
    title:'Vampire'
  },{
    name:'Karma',
     title:'Karma'
  },
    {
       name:'rajdhani',
       title:'rajdhani'
    },
    {
      name:'caveat',
      title:'caveat'
    },
    {
      name:'Raleway',
      title:'Raleway'
    },
    {
      name:'Shadows',
      title:'shadows'
    },
    {
      name:'Zeyada',
      title:'Zeyada'
    },
    {
      name:'GreatVibe',
      title:'GreatVibe'
    },
    {
     name:'Geologica',
     title:'Geologica'
    },
    {
      name:'Gruppo',
      title:'Gruppo'
    },
    {
      name:'Poppins',
      title:'Poppins'  
    },
    {
     name:'DancingScript',
     title:'DancingScript'
    },
    {
      name:'Kalam',
      title:'Kalam'
    },
    {
      name:'Sarpanch',
      title:'Sarpanch'
    },
    {
      name:'FugazOne',
      title:'Fugazone'
    }
];

export default font;


    // let tp = temp6.current;
    // tp.style.zIndex="0";
    // var scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
    // scrollTop+=8;
    // tp.style.color="transparent";
    // tp.style.top=`${scrollTop}px`;